export default __webpack_public_path__ + "static/media/dropdown-arrow.9e7a426a.svg";